import React from 'react';
import ClaseOnline from '../images/clases-online.jpg';
import './Home.css';

const BannerClases = () => {
    return ( 
    
    <section className="minota-promo-section">
        <div className="minota-promo-container">
          <div className="minota-promo-content">
            <span className="minota-badge">CLASES ONLINE EN VIVO</span>
            
            <h2 className="minota-title">
              Aprende <br/>
              <span className="minota-gradient-text">desde donde estés</span>
            </h2>
            
            <ul className="minota-features-list">
              <li className="minota-feature-item">
                <div className="minota-icon-wrapper">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><path d="M20 21v-2a4 4 0 0 0-4-4H8a4 4 0 0 0-4 4v2"/><circle cx="12" cy="7" r="4"/></svg>
                </div>
                <div className="minota-feature-text">
                  <strong>Profesor en vivo</strong>
                  <span>Atención personalizada</span>
                </div>
              </li>
              
              <li className="minota-feature-item">
                <div className="minota-icon-wrapper">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="3" y="4" width="18" height="18" rx="2" ry="2"/><line x1="16" y1="2" x2="16" y2="6"/><line x1="8" y1="2" x2="8" y2="6"/><line x1="3" y1="10" x2="21" y2="10"/></svg>
                </div>
                <div className="minota-feature-text">
                  <strong>Horarios flexibles</strong>
                  <span>Tú eliges cuándo</span>
                </div>
              </li>
              
              <li className="minota-feature-item">
                <div className="minota-icon-wrapper">
                  <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="2"><rect x="2" y="3" width="20" height="14" rx="2" ry="2"/><line x1="8" y1="21" x2="16" y2="21"/><line x1="12" y1="17" x2="12" y2="21"/></svg>
                </div>
                <div className="minota-feature-text">
                  <strong>Desde cualquier lugar</strong>
                  <span>Solo necesitas tu dispositivo</span>
                </div>
              </li>
            </ul>
            
            <a href="https://clases.minotamusic.com/" className="minota-btn-action">
              Conoce las clases online 
              <span className="minota-btn-arrow">&rarr;</span>
            </a>
          </div>
          <div className="minota-promo-image-box">
            <img src={ClaseOnline} alt="Clases de música online en vivo" class="minota-main-img" />
          </div>

        </div>
      </section>
    )
}

export default BannerClases